module.exports = __webpack_public_path__ + "media/images/temp/icon-1-a18efe99831ff0b3e1ff05ec6e1f0e8f.png";